module.exports = __webpack_public_path__ + "img/c05_unittechbalearicslingerchampion_Normal_ua.d4911aaa.webp";